import React,{useRef, useState, useEffect} from "react";
import { Toast, ToastContainer, Form, Container, Row, Col} from "react-bootstrap";

import { ArrowUp, CircleNotch, ArrowsOutSimple, ArrowsInSimple} from "@phosphor-icons/react";
import {formatDate, isNumeric} from "../utils/functions";
import * as yup from 'yup';
import * as formik from 'formik';
import schemas from "../data/dataSchemas";
import vindrApi from "../utils/vindrapi";
import globalContext from "../utils/globalContext";


const { Formik } = formik;

class QuickAnnotation extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			sent: false,
			valid: false,
			loading: false,
			editMode: isNumeric(this.props.annotation.id) ? (this.props.edit ? true : false): true,
			touched: {},
			errors : {},
			expanded:false
		};
		
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	
	handleEnter(){
		
		this.updateStatus({
			bg:this.props.setup && this.props.setup.bg ? this.props.setup.bg : this.state.bg
		});
		
		
	}
	show(message){
		this.updateStatus({setup:{open:true, text:message}}	)
	}
	handleChange = (e)=>{
		
		const newTouched = {...this.state.touched};
		
		newTouched[e.target.name] = true;
		const isValid = e.target.value.length ? true : false;
		
		var newState = {touched:newTouched, valid: isValid}
		
		if(!isValid)
			newState = {...newState, ...{errors:{message:'Please provide a comment'}}};
		
		this.updateStatus({touched:newTouched, valid: isValid});
		
	}
	handleClose(){
		
		this.updateStatus({setup:{open:false, text:''}});
	}
	
	handleSubmit = (e)=>{
		e.preventDefault();
		
		const form = e.target.closest("form");
		const params = new FormData(form);

		var data = this.props.annotation;
		params.forEach((value, key) => data[key] = value);	
		
		if(this.state.valid && data.scenario_id && data.project_id){
			
			this.updateStatus({loading:true});
			const fn = Number.isInteger(parseInt(data.id)) ? 'updateAnnotations' : 'createAnnotations';
			
			if(this.props.context && this.props.context.getters.user)
				data.username = this.props.context.getters.user.userDetails;
			
			vindrApi[fn](data.project_id, data.scenario_id, data).then((result)=>{
				
				if(this.props.onFinish){
					this.props.onFinish(result);
				}
				
				this.updateStatus({
					loading:false,
					touched:{},
					sent:true,
					editMode:false,
					valid:false
				})
				
			});
		}
	
	}
	handleKeyPress = (e)=>{
		if (e.keyCode == 13 && !e.shiftKey) {
			e.preventDefault();
			this.handleSubmit(e);
		}
	}
	handleClick = () => {
		
		this.updateStatus({editMode:true});
	}
	toggleExpand = (e) => {
		e.stopPropagation();
		this.updateStatus({
			expanded: !this.state.expanded
		})
		
	}

	render() {
		
		
		return (
			<div className={"quickannotation " + (this.state.editMode ? 'editmode':'') + (this.state.expanded ? 'expanded':'')}>
				<Container className="p-2 " onClick={this.handleClick}>
					<Form noValidate onSubmit={this.handleSubmit}>
						<div className="metadata">
							<div className="user">{this.props.annotation.username}</div>
							<div className="date">{formatDate(this.props.annotation.timestamp, 'short')}</div>
						</div>
						<Row>
							<Form.Group as={Col} md="12" className="text-field">
								{this.state.editMode ? 
									(
										<Form.Control 
											as="textarea"
											onKeyDown={this.handleKeyPress}
											defaultValue={ this.props.annotation.text }
											onChange={this.handleChange} 
											name="text" 
											placeholder="Add comment" 
										/>
									):(
										<>
											<div className="viewtext">{this.props.annotation.text.replace(/(\r\n|\n|\r)/gm, " ")}</div>
											{!!this.props.annotation.image_url &&
												<div className="viewimage">
													<img src={this.props.annotation.image_url} />
													<div className="expand" onClick={this.toggleExpand}>
														{!this.state.expanded && <ArrowsOutSimple size={16} /> }
														{this.state.expanded &&  <ArrowsInSimple size={16} /> }
													</div>
												</div>
											}
										</>
									)
								}

								<button type="submit" disabled={this.state.valid || this.state.loading ? false : true} className={this.state.loading ? 'loading':''} >
									<ArrowUp className="arrow" size={20} />
									<CircleNotch className="spin" size={20} />
								</button>
							</Form.Group>
							<Form.Control.Feedback>
								{!!this.state.errors && this.state.errors.message}
							</Form.Control.Feedback>
						</Row>
					</Form>
				</Container>
			</div>
		);
	}
}

QuickAnnotation.contextType = globalContext;

export default QuickAnnotation;